import axios from 'axios';
import { DevicePreviewBuilder } from '@beef/shop-common';
import { captureException } from '@sentry/react';

import { COOKIES_NAMES } from 'constants/cookies';
import { cookiesDataService } from 'services/cookiesDataService';
import { getBasketProductIds } from 'store/common/basket/selectors';
import { cookieBasketService } from 'services/cookieBasketService';
import { getCurrentRegionCode } from 'store/common/settings/selectors';
import { getCookie } from 'utils/cookie';
import { hideAllModal } from 'store/common/modal/actions';

import { DETAILS_MODAL_ACTIONS } from './constants';
import { getProductDeviceDetailsData } from './selectors';
import { cartApi } from '../../../api';

// FETCH DATA ACTIONS
export const fetchProductDeviceDetailsDataStart = () => ({
  type: DETAILS_MODAL_ACTIONS.FETCH_DETAILS_MODAL,
});

export const fetchProductDeviceDetailsDataSuccess = (payload) => ({
  type: DETAILS_MODAL_ACTIONS.FETCH_DETAILS_MODAL_SUCCESS,
  payload,
});

export const fetchProductDeviceDetailsDataError = () => ({
  type: DETAILS_MODAL_ACTIONS.FETCH_DETAILS_MODAL_ERROR,
});

export const setProductDeviceDetailsIsFavoriteData = (payload) => (dispatch) => {
  dispatch({
    type: DETAILS_MODAL_ACTIONS.SET_DEVICE_IS_FAVORITE,
    payload,
  });
};

export const setProductDeviceDetailsIsCmpData = () => ({
  type: DETAILS_MODAL_ACTIONS.SET_DEVICE_IS_CMP,
});
export const setProductDeviceDetailsIsPurchaseLoading = (payload) => ({
  type: DETAILS_MODAL_ACTIONS.SET_DEVICE_IS_PURCHASE_LOADING,
  payload,
});

export const fetchProductDeviceDetailsData = (slug) => async (dispatch, getState) => {
  try {
    const state = getState();
    const basketIds = getBasketProductIds(state);
    dispatch(fetchProductDeviceDetailsDataStart());
    const currentSlug = slug.includes('/shop/details') ? slug.replace('/shop/details', '') : slug;

    const { data } = await axios.get(`/shop/popupdetails/${currentSlug}/`);

    const favoriteList = cookiesDataService.getDataList(COOKIES_NAMES.FAVORITE_DEVICES);
    // TODO fix cmp like favorite device
    const cmpCookieVal = getCookie(COOKIES_NAMES.COMPARISON_DEVICES);
    const cmpList = cmpCookieVal ? JSON.parse(`${cmpCookieVal}`) : '[]';
    // TODO fix Builder
    const device = new DevicePreviewBuilder()
      .setDeviceId(data)
      .setDeviceName(data)
      .setDeviceBrandName(data)
      .setDeviceLink(data)
      .setDeviceCharacteristics(data)
      .setDevicePromoBadges(data)
      .setDeviceIsFlocktory(data, true)
      .setDeviceIsInBasket(data, basketIds)
      .setDeviceIsFavorite(data, favoriteList)
      .setDeviceIsCmp(data, cmpList)
      .setDeviceBrand(data)
      .setDeviceArticle(data)
      .setDeviceCategoryId(data)
      .setDeviceIsPreorder(data)
      .setDeviceImgOptions(data)
      .setDeviceCapacity(data)
      .setDeviceTypes(data)
      .setDeviceColor(data)
      .setDeviceIsOutOfStock(data)
      .setDeviceReviews(data)
      .setDevicePromoSubscribe(data)
      .setDevicePromosubscribeSaleSoon(data)
      .setDevicePromosubscribeSalePersonalDataLink(data)
      .setDevicePromoBundle(data)
      .setDevicePromoCode(data)
      .setDevicePrice(data)
      .setDeviceOldPrice(data)
      .setDeviceDiscount(data)
      .setDeviceIsSended(data)
      .setDevicePromoCredit(data)
      .setDeviceContentType(data)
      .getDeviceData();

    dispatch(fetchProductDeviceDetailsDataSuccess(device));
  } catch (error) {
    captureException(error);
    dispatch(fetchProductDeviceDetailsDataError());
  }
};

export const addDeviceToBasketThunk = () => async (dispatch, getState) => {
  try {
    const state = getState();
    const regionPath = getCurrentRegionCode(state);
    const { id, isInBasket } = getProductDeviceDetailsData(state);

    const basketId = cookieBasketService.getBasketIdCookie();

    dispatch(setProductDeviceDetailsIsPurchaseLoading(true));

    if (isInBasket) {
      window.location.href = '/basket/';
    }

    const items = [
      {
        id,
        quantity: 1,
        itemType: 'product',
      },
    ];

    if (basketId) {
      await cartApi.basketMergeItems(basketId, items);
    } else {
      const data = await cartApi.basketCreateBasket(
        cartApi.helpers.createBasketData(items, regionPath),
      );

      cookieBasketService.setBasketIdCookie(data?.id);
    }

    window.location.href = '/basket/';

    dispatch(setProductDeviceDetailsIsPurchaseLoading(false));
    dispatch(hideAllModal());
  } catch (error) {
    captureException(error);
    dispatch(setProductDeviceDetailsIsPurchaseLoading(false));
    dispatch(hideAllModal());
  }
};
